<div class="dialog-container">
  <div class="dialog-header">
    <oph-back-button (buttonClick)="onClose()" />
  </div>

  <div class="dialog-content">
    <div class="chart-detail-card" [style.--metric-color]="metricProgressColor()">
      <cs-chart-detail-dialog-header
        [icon]="data.metric.taskIcon"
        [name]="data.metric.metricName"
        [percentComplete]="percentComplete()"
        [currentValueDisplay]="currentValueDisplay()"
        [targetValueDisplay]="targetValueDisplay()"
        [progressColor]="metricProgressColor()"
      />

      <div class="history-section">
        @if (historyRowsWithNormalized().length) {
          <div class="history-rows">
            @for (item of historyRowsWithNormalized(); track $index) {
              <div class="pill-row">
                @for (fill of item.normalizedValues; track $index) {
                  <div class="pill-track" [matTooltip]="item.tooltipValues[$index]" matTooltipPosition="above">
                    <div class="pill-fill" [style.width.%]="fill * 100"></div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
